var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5106_725)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M494.038 210.752L448 164.715V128C448 92.7151 419.286 64.0005 384 64.0005H347.286L301.27 17.9844C277.078 -6.18622 234.923 -6.18622 210.752 17.9844L164.715 64.0005H128C92.7149 64.0005 64.0002 92.7151 64.0002 128V164.715L17.9629 210.752C-6.95443 235.712 -6.95443 276.288 17.9629 301.248L64.0002 347.286V384C64.0002 419.286 92.7149 448 128 448H164.715L210.731 494.016C222.827 506.091 238.891 512.768 256 512.768C273.11 512.768 289.174 506.112 301.248 494.016L347.286 448H384C419.286 448 448 419.286 448 384V347.286L494.038 301.248C518.955 276.288 518.955 235.712 494.038 210.752ZM256 405.334C238.336 405.334 224 390.998 224 373.334C224 355.67 238.336 341.334 256 341.334C273.664 341.334 288 355.67 288 373.334C288 390.998 273.664 405.334 256 405.334ZM286.87 269.419C282.859 271.616 277.334 281.43 277.334 288.107V298.667C277.334 310.464 267.776 320 256 320C244.224 320 234.667 310.464 234.667 298.667V288.107C234.667 266.07 248.256 241.963 266.262 232.043C272.448 228.651 278.955 220.63 276.971 209.302C275.499 200.939 268.395 193.835 260.054 192.384C253.526 191.168 247.211 192.832 242.304 196.992C237.44 201.046 234.667 207.019 234.667 213.355C234.667 225.152 225.11 234.688 213.334 234.688C201.558 234.688 192 225.152 192 213.355C192 194.39 200.342 176.512 214.87 164.31C229.376 152.107 248.534 146.944 267.414 150.379C293.206 154.88 314.432 176.086 318.976 201.942C323.734 229.078 310.827 256.192 286.848 269.44L286.87 269.419Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5106_725"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.15d326dde6d7036e6e10526d696541bb.svg";
export { ForwardRef as ReactComponent };